// Shared axis config for the GWP vs MCI / GWP vs PCI bubble charts.

// Each material's absolute GWP on a logarithmic Y axis; bubble size follows the same value.
export const GWP_LOG_AXIS = { type: "number", dataKey: "gwp_total", name: "GWP", unit: "kg CO₂e", scale: "log" };
